<app-events-calendar #eventsCalendar [streamingData]="true" (eventClicked)="makeRequestTable.addEvent($event)">
</app-events-calendar>

<app-make-event-request-table #makeRequestTable [selectedEventType]="eventsCalendar.selectedEventTypes.value">
</app-make-event-request-table>
